import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { ThemeCustomizerService } from '../../../common/theme-customizer/theme-customizer.service';

interface EventItem {
  id?: number;
  event_title: string;
  event_date: string;
  event_image: string;
  created_at?: string;
}
interface ContentSlide {
  title: string;
  description: string;
  image?: string;
  ctaText?: string;
  ctaLink?: string;
  ctaExternalLink?: string;
}

interface VideoSlide {
  title: string;
  description: string;
  source: string;
  poster?: string;
  externalUrl?: string;
}

interface CoursePopupItem {
  title: string;
  subtitle: string;
  approval?: string;
  intake?: string;
  overview: string;
  scopeTitle: string;
  scopePoints: string[];
}

@Component({
  selector: 'app-homenine-main-banner',
  templateUrl: './homenine-main-banner.component.html',
  styleUrls: ['./homenine-main-banner.component.scss'],
})
export class HomenineMainBannerComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  isToggled = false;
  naacVisitVideoUrl = 'https://youtu.be/_yXQpi2juuY?si=46HW7J7GdhKQm3-y';
  marqueeList: string[] = [];
  eventList: EventItem[] = [];

  selectedEventImage: string | null = null;
  selectedEventDescription: string | null = null;

  selectedCoursePopup: CoursePopupItem | null = null;

  coursePopupMap: Record<string, CoursePopupItem> = {
    aids: {
      title: 'B.Tech. Artificial Intelligence & Data Science',
      subtitle:
        'A newly introduced programme focused on intelligent systems, analytics, and data-driven innovation.',
      approval: 'New Programme',
      intake: 'Admissions Open 2026',
      overview:
        'B.Tech. Artificial Intelligence & Data Science is designed to equip students with strong foundations in artificial intelligence, machine learning, data analytics, statistics, programming, and intelligent decision-making systems. The programme helps students build future-ready skills for solving real-world problems using data and smart technologies.',
      scopeTitle: 'Scope of Artificial Intelligence & Data Science',
      scopePoints: [
        'To understand the fundamentals of artificial intelligence, machine learning, and data science.',
        'To develop smart systems that can learn, predict, analyze, and automate decision-making.',
        'To work with real-world data for business intelligence, healthcare, finance, agriculture, and public services.',
        'To build strong programming, analytical, and problem-solving skills for emerging technologies.',
        'To explore career opportunities in AI engineering, data analysis, machine learning, automation, and research.',
        'To contribute to innovation in intelligent applications, digital transformation, and industry-focused solutions.',
      ],
    },
    environmentalEngineering: {
      title: 'M.E. Environmental Engineering',
      subtitle:
        'AICTE approved PG program (M.E. Environmental Engineering) during the academic year 2026-27.',
      approval: 'AICTE Approved',
      intake: 'Intake: 18',
      overview:
        'Environmental Engineering is the application of science and engineering principles that provide a better environment, to give healthy water, air and land for human habitation and other living things, and to rehabilitate polluted areas. In addition, it focuses on finding appropriate solutions in the field of public health, such as arthropod-related diseases, and in enforcing laws that promote adequate sanitation in urban, rural, and recreational areas.',
      scopeTitle: 'Scope of Environmental Engineering',
      scopePoints: [
        'To clarify modern environmental concept like how to conserve biodiversity.',
        'To know the more sustainable way of living.',
        'To use natural resources more efficiently.',
        'To know the behavior of organism under natural conditions.',
        'To know the interrelationship between organisms in populations and communities.',
        'To aware and educate people regarding environmental issues and problems at local, national and international levels.',
        'Global crises on environment can be minimized by utilizing Environmental Engineering technology.',
      ],
    },
  };

  private themeSub?: Subscription;
  private videoQuerySub?: Subscription;

  @ViewChild('videoViewport', { static: false })
  videoViewport?: ElementRef<HTMLDivElement>;

  @ViewChildren('heroVideo')
  heroVideos?: QueryList<ElementRef<HTMLVideoElement>>;

  private videoObserver?: IntersectionObserver;
  private initialVideoBootTimer?: number;
  private readonly maxVideoRetries = 5;
  private videoRetryTimers = new Map<HTMLVideoElement, number>();

  private readonly handleVisibilityChange = (): void => {
    if (typeof document === 'undefined') return;

    if (document.hidden) {
      this.heroVideos?.forEach((videoRef) => {
        this.pauseVideo(videoRef.nativeElement);
      });
      return;
    }

    window.setTimeout(() => {
      this.setupVideoAutoplay();
    }, 150);
  };

  backgroundImages: string[] = [
    'assets/img/main-banner3.jpg',
    'assets/img/main-banner4.jpg',
    'assets/img/main-banner5.jpg',
    'assets/img/main-banner1.jpg',
    'assets/img/main-banner2.jpg',
  ];

  contentSlides: ContentSlide[] = [
{
  title: 'FMCET is Now NAAC A+ Accredited',
  description:
    '"FMCET achieves accreditation by NAAC with A+ Grade! A proud milestone in our journey of excellence in education."',
  image: 'assets/img/aplus.png',
  ctaText: 'NAAC Team Visit',
  ctaExternalLink: 'https://youtu.be/_yXQpi2juuY?si=46HW7J7GdhKQm3-y',
},
    {
      title: 'FMCET is Now Autonomous',
      description:
        'We are proud to announce that FMCET has been conferred Autonomous Status by UGC, a testament to our commitment to academic excellence and innovation.',
      image: 'assets/img/autonomous.png',
    },
    {
      title: 'Admissions Open for 2026',
      description:
        'Join FMCET to experience modern infrastructure, strong academic culture, vibrant campus life, and career-focused learning across UG and PG programmes.',
      image: 'assets/img/15years.png',
      ctaText: 'Apply Now',
      ctaLink: '/inquiry',
    },
  ];

  videoSlides: VideoSlide[] = [
    {
      title: 'Innover 2K25',
      description:
        'Innovation project display conducted for all students, showcasing ideas, creativity, and practical problem-solving projects.',
      source: 'assets/videos/home-video-01.mp4',
      poster: 'assets/img/main-banner3.jpg',
      externalUrl: 'assets/videos/home-video-01.mp4',
    },
    {
      title: 'MPC Productivity Week - Valedictory Function',
      description:
        'Valedictory function conducted for school students, celebrating participation, achievement, and successful completion of the programme.',
      source: 'assets/videos/home-video-02.mp4',
      poster: 'assets/img/main-banner4.jpg',
      externalUrl: 'assets/videos/home-video-02.mp4',
    },
    {
      title: 'Annual Day Celebration',
      description:
        'Annual Day celebration featuring cultural performances, student participation, stage events, and memorable campus moments.',
      source: 'assets/videos/home-video-03.mp4',
      poster: 'assets/img/main-banner5.jpg',
      externalUrl: 'assets/videos/home-video-03.mp4',
    },
    {
      title: 'Sports Activities',
      description:
        'Sports activities and physical events conducted for both staff and students, promoting fitness, teamwork, and sportsmanship.',
      source: 'assets/videos/home-video-04.mp4',
      poster: 'assets/img/main-banner1.jpg',
      externalUrl: 'assets/videos/home-video-04.mp4',
    },
    {
      title: 'Farewell Day - 27/03/2026',
      description:
        'Farewell Day celebration highlight video featuring send-off moments for outgoing students, cultural performances, memories with friends and faculty, and the joyful atmosphere across the campus.',
      source: 'assets/videos/home-video-05.mp4',
      poster: 'assets/img/main-banner2.jpg',
      externalUrl: 'assets/videos/home-video-05.mp4',
    },
  ];

  middleCarouselOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    smartSpeed: 900,
    items: 1,
    dots: true,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
  };

  leftOverlayCarouselOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 900,
    items: 1,
    dots: true,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
  };

  apiUrlEvents = 'https://fmcet.ac.in/backend/getEvent.php';
  apiUrlMarquee = 'https://fmcet.ac.in/backend/getMarquee.php';

  constructor(
    private http: HttpClient,
    public themeService: ThemeCustomizerService,
    private ngZone: NgZone
  ) {
    this.themeSub = this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {
    this.loadMarqueeData();
    this.loadEventData();
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      window.setTimeout(() => {
        this.setupVideoAutoplay();
      }, 120);

      this.videoQuerySub = this.heroVideos?.changes.subscribe(() => {
        this.setupVideoAutoplay();
      });

      if (typeof document !== 'undefined') {
        document.addEventListener(
          'visibilitychange',
          this.handleVisibilityChange
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
    this.videoQuerySub?.unsubscribe();

    if (typeof document !== 'undefined') {
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      document.body.style.overflow = '';
    }

    this.destroyVideoAutoplay();
  }

  get shouldAnimateVideos(): boolean {
    return this.videoSlides.length > 1;
  }

  get renderedVideoSlides(): VideoSlide[] {
    return this.shouldAnimateVideos
      ? [...this.videoSlides, ...this.videoSlides]
      : this.videoSlides;
  }

  get videoScrollDuration(): string {
    const seconds = Math.max(this.videoSlides.length * 6, 28);
    return `${seconds}s`;
  }

  trackByEvent(index: number, item: EventItem): string | number {
    return item.id ?? `${item.event_title}-${item.event_date}-${index}`;
  }

  trackByVideo(index: number, item: VideoSlide): string {
    return `${item.title}-${index}`;
  }
isNaacMarquee(marquee: string): boolean {
  const text = String(marquee || '').toLowerCase();
  return text.includes('naac') || text.includes('peer team visit') || text.includes('video');
}
  loadMarqueeData(): void {
    this.http.get<string[]>(this.apiUrlMarquee).subscribe({
      next: (data) => {
        this.marqueeList =
          Array.isArray(data) && data.length
            ? data
            : ['No marquee content available'];
      },
      error: (error) => {
        console.error('Error loading marquee:', error);
        this.marqueeList = ['Error loading marquee data.'];
      },
    });
  }

  loadEventData(): void {
    this.http.get<EventItem[]>(this.apiUrlEvents).subscribe({
      next: (data) => {
        this.eventList = Array.isArray(data) ? data : [];
      },
      error: (error) => {
        console.error('Error loading events:', error);
        this.eventList = [];
      },
    });
  }

  showPopup(index: number): void {
    const event = this.eventList[index];
    if (!event) return;
    this.showPopupByEvent(event);
  }

  showPopupByEvent(event: EventItem): void {
    if (!event) return;

    this.selectedEventImage = this.getEventImage(event.event_image);
    this.selectedEventDescription = `${this.formatEventDate(
      event.event_date
    )} - ${event.event_title}`;
  }

  closePopup(): void {
    this.selectedEventImage = null;
    this.selectedEventDescription = null;
  }

  showCoursePopup(courseKey: string): void {
    const popup = this.coursePopupMap[courseKey];
    if (!popup) return;

    this.selectedCoursePopup = popup;

    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    }
  }

  closeCoursePopup(): void {
    this.selectedCoursePopup = null;

    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  }

  getEventImage(imagePath?: string | null): string {
    if (!imagePath) {
      return 'assets/img/main-banner1.jpg';
    }

    const trimmed = imagePath.trim();

    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }

    if (trimmed.startsWith('assets/')) {
      return trimmed;
    }

    const cleanedPath = trimmed.replace(/^\/+/, '');

    if (cleanedPath.startsWith('backend/')) {
      return `https://fmcet.ac.in/${cleanedPath}`;
    }

    return `https://fmcet.ac.in/backend/${cleanedPath}`;
  }

  formatEventDate(dateValue?: string): string {
    if (!dateValue) return '';

    const parsed = new Date(dateValue);

    if (Number.isNaN(parsed.getTime())) {
      return dateValue;
    }

    return new Intl.DateTimeFormat('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(parsed);
  }

  onVideoMeta(video: HTMLVideoElement): void {
    this.tryPlayVideo(video, 0);
  }

  onVideoCanPlay(video: HTMLVideoElement): void {
    this.tryPlayVideo(video, 0);
  }

  onVideoError(video: HTMLVideoElement): void {
    const source = video.querySelector('source');
    console.warn(
      'Hero video failed to load:',
      source?.getAttribute('data-src') ||
        source?.getAttribute('src') ||
        video.currentSrc
    );
  }

  private setupVideoAutoplay(): void {
    if (
      typeof window === 'undefined' ||
      !this.videoViewport?.nativeElement ||
      !this.heroVideos
    ) {
      return;
    }

    this.destroyVideoObserver();

    const rootElement = this.videoViewport.nativeElement;

    this.videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target as HTMLVideoElement;

          if (entry.isIntersecting && entry.intersectionRatio > 0.15) {
            const eager = entry.intersectionRatio > 0.55;
            this.activateVideo(video, eager);
          } else {
            this.pauseVideo(video);
          }
        });
      },
      {
        root: rootElement,
        rootMargin: '140px 0px 140px 0px',
        threshold: [0.15, 0.35, 0.55, 0.8],
      }
    );

    this.heroVideos.forEach((videoRef, index) => {
      const video = videoRef.nativeElement;
      this.prepareVideoElement(video, index);
      this.videoObserver?.observe(video);
    });

    window.clearTimeout(this.initialVideoBootTimer);

    this.initialVideoBootTimer = window.setTimeout(() => {
      const initialVideos = this.heroVideos?.toArray().slice(0, 2) ?? [];
      initialVideos.forEach((videoRef) => {
        this.activateVideo(videoRef.nativeElement, true);
      });
    }, 180);
  }

  private prepareVideoElement(
    video: HTMLVideoElement,
    index: number
  ): void {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', 'true');
    video.setAttribute('preload', index < 2 ? 'metadata' : 'none');

    video.preload = index < 2 ? 'metadata' : 'none';

    if (!video.dataset['retryCount']) {
      video.dataset['retryCount'] = '0';
    }
  }

  private activateVideo(
    video: HTMLVideoElement,
    eager = false
  ): void {
    const sourceAttached = this.ensureVideoSource(video);

    if (eager) {
      video.preload = 'auto';
      video.setAttribute('preload', 'auto');
    } else if (video.preload === 'none') {
      video.preload = 'metadata';
      video.setAttribute('preload', 'metadata');
    }

    if (sourceAttached || video.readyState === 0) {
      video.load();
    }

    this.tryPlayVideo(video, eager ? 0 : 150);
  }

  private ensureVideoSource(video: HTMLVideoElement): boolean {
    const source = video.querySelector('source');
    if (!source) return false;

    const currentSrc = source.getAttribute('src')?.trim();
    const dataSrc = source.getAttribute('data-src')?.trim();

    if (!currentSrc && dataSrc) {
      source.setAttribute('src', dataSrc);
      return true;
    }

    return false;
  }

  private tryPlayVideo(
    video: HTMLVideoElement,
    delayMs = 0
  ): void {
    this.clearVideoRetryTimer(video);

    const startPlayback = () => {
      if (!video.isConnected) return;

      const playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            video.dataset['retryCount'] = '0';
          })
          .catch(() => {
            this.queueVideoRetry(video);
          });
      }
    };

    if (delayMs <= 0) {
      startPlayback();
      return;
    }

    const timerId = window.setTimeout(startPlayback, delayMs);
    this.videoRetryTimers.set(video, timerId);
  }

  private queueVideoRetry(video: HTMLVideoElement): void {
    const retryCount = Number(video.dataset['retryCount'] ?? '0');

    if (retryCount >= this.maxVideoRetries) {
      return;
    }

    video.dataset['retryCount'] = String(retryCount + 1);

    const waitTime = Math.min(500 + retryCount * 700, 3200);

    this.clearVideoRetryTimer(video);

    const timerId = window.setTimeout(() => {
      const sourceAttached = this.ensureVideoSource(video);

      if (sourceAttached || video.readyState < 2) {
        video.load();
      }

      this.tryPlayVideo(video, 0);
    }, waitTime);

    this.videoRetryTimers.set(video, timerId);
  }

  private pauseVideo(video: HTMLVideoElement): void {
    this.clearVideoRetryTimer(video);

    if (!video.paused) {
      video.pause();
    }
  }

  private clearVideoRetryTimer(video: HTMLVideoElement): void {
    const timerId = this.videoRetryTimers.get(video);

    if (timerId) {
      window.clearTimeout(timerId);
      this.videoRetryTimers.delete(video);
    }
  }

  private destroyVideoObserver(): void {
    this.videoObserver?.disconnect();
    this.videoObserver = undefined;
  }

  private destroyVideoAutoplay(): void {
    this.destroyVideoObserver();

    if (this.initialVideoBootTimer) {
      window.clearTimeout(this.initialVideoBootTimer);
      this.initialVideoBootTimer = undefined;
    }

    this.videoRetryTimers.forEach((timerId) => {
      window.clearTimeout(timerId);
    });
    this.videoRetryTimers.clear();

    this.heroVideos?.forEach((videoRef) => {
      const video = videoRef.nativeElement;
      video.pause();
    });
  }
}